import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatMenuTrigger, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../../helpers';
import { Content, ContentDeleteConfirmation, User } from '../../models';
import { ConfirmDialog } from '../dialog/confirm.dialog';
import { EditThumbnailDialog } from '../dialog/edit-thumbnail.dialog';
import { ContentService } from './../../services/content.service';
import { ConvertToStructuredDialog } from './convert-to-structured.dialog';
import { EditContentDialog } from './edit-content.dialog';
import { ExportContentSnack } from './export-content.snack';
import { ContentInfoDialog } from './info.dialog';
import { ManageCollaboratorsDialog } from './manage-collaborator.dialog';

@Component({
  selector: 'content-card',
  styleUrls: ['./content.css'],
  templateUrl: './content-card.component.html',
})
export class ContentCardComponent implements AfterViewInit {
  @ViewChild(MatMenuTrigger) set setContextMenu(contextMenu: MatMenuTrigger) {
    if (contextMenu) {
      this.contextMenu = contextMenu;
    }
  }
  public canEdit: boolean;
  public item;
  public contextMenu: MatMenuTrigger;
  public contextMenuPosition = { x: '0px', y: '0px' };

  @Input() public content: Content;
  @Input() public currentUser: User;
  @Output() public cardEvent = new EventEmitter();

  public bgColor: string;

  constructor(
    private contentService: ContentService,
    private dialog: MatDialog,
    private router: Router,
    private snackBar: MatSnackBar,
    private toastr: ToastrService) {
  }
  public ngAfterViewInit(): void {
    this.canEdit = (this.currentUser.type == 3 || this.currentUser._id == this.content.owner._id);
  }

  public onContextMenu(event: MouseEvent) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.openMenu();
    // prevent context menu on backdrop
    const backdrop = document.getElementsByClassName('cdk-overlay-container');
    if (backdrop && backdrop.item(0)) { backdrop.item(0).addEventListener('contextmenu', event => { event.preventDefault(); }); }
  }

  public onMenuThumbnail() {
    this.dialog
      .open(EditThumbnailDialog, { width: '30%', panelClass: 'custom-modal-thumbnail', data: { type: 'content', _id: this.content._id, currentPhoto: this.content.thumbnailPath } })
      .afterClosed()
      .subscribe((data) => {
        if (data && data.thumbnailPath) {
          this.content.thumbnailPath = data.thumbnailPath;
        }
        this.cardEvent.emit('refresh');
      });
  }

  public onMenuEdit() {
    this.dialog.open(EditContentDialog, { data: { content: this.content } }).afterClosed().subscribe((data) => {
      if (data) {
        this.cardEvent.emit('refresh');
      }
    });
  }
  public onMenuConvertToStructured() {
    this.dialog.open(ConvertToStructuredDialog, { data: this.content });
  }
  public onMenuExport() {
    this.snackBar.openFromComponent(ExportContentSnack, { data: this.content });
  }

  public onMenuInfo() {
    this.dialog.open(ContentInfoDialog, { width: '75%', data: this.content });
  }
  public onMenuManageCollaborators() {
    this.dialog.open(ManageCollaboratorsDialog, { width: '75%', data: this.content });
  }

  public onMenuDelete() {
    this.dialog
      .open(ConfirmDialog, {
        data: new ContentDeleteConfirmation(this.content),
        minWidth: '150px',
      })
      .afterClosed()
      .subscribe((data) => {
        if (data && data.confirmed) {
          this.contentService.delete(this.content._id, data.tick).subscribe(() => {
            this.toastr.success('Content successfully deleted');
            this.cardEvent.emit('refresh');
          });
        }
      });
  }

  public getAverageColor() {
    if (!this.bgColor && !this.content.thumbnailPath.includes('no-image')) {
      const img = document.getElementById('contentImage-' + this.content._id);
      this.bgColor = this.calcAverage(img);
    }
  }

  public calcAverage(img) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const width = (canvas.width = img.naturalWidth);
    const height = (canvas.height = img.naturalHeight);
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;
    let r = 0;
    let g = 0;
    let b = 0;

    for (let i = 0, l = data.length; i < l; i += 4) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
    }

    r = Math.floor(r / (data.length / 4));
    g = Math.floor(g / (data.length / 4));
    b = Math.floor(b / (data.length / 4));

    return this.rgbToHex(r, g, b);
  }

  public componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  public rgbToHex(r, g, b) {
    return (
      '#' +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b)
    );
  }
}
